import React, { useState } from "react";
import "./faq.css";
import NavigationBar from "./NavigationBar";

function FAQ() {
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setOpenQuestion(openQuestion === key ? null : key);
  };

  const faqData = [
    {
      category: "Platform Overview",
      questions: [
        {
          question: "What is Radar+?",
          answer:
            "Radar+ is your AI command center, delivering complete strategic awareness and execution automation. It scans risks and opportunities in real-time, then acts with precision—so you stay in control without the hassle.",
        },
        {
          question: "What powers Radar+?",
          answer:
            "At the core is our Engine — a real-time processor that reads your tech and ERP data, identifies key shifts, and launches automatic workflows in response. No guesswork. Just results.",
        },
        {
          question: "How is this different from dashboards or reporting tools?",
          answer:
            "Dashboards show you what already happened. Radar+ shows what to do next — and actually does it. It’s execution-first intelligence, not just analytics.",
        },
      ],
    },
    {
      category: "The Engine (How It Works)",
      questions: [
        {
          question: "What data does the Engine analyze?",
          answer:
            "It connects to:<br />• Financial & project systems<br />• Emails, calendars, task managers<br />• Industry and market data<br />Then it detects patterns and anomalies in real time to act fast and with context.",
        },
        {
          question: "What kind of actions does it take?",
          answer:
            "It can assign tasks, trigger alerts, launch workflows, and send briefings. You set the rules — it enforces them automatically.",
        },
        {
          question: "Can I override or approve actions?",
          answer:
            "Yes. The Engine can run in auto-mode or assistive mode. You choose what gets sent instantly and what gets routed for approval.",
        },
      ],
    },
    {
      category: "Outcomes & Benefits",
      questions: [
        {
          question: "What kind of ROI can I expect?",
          answer:
            "Our users have reported:<br />• 30–50% faster responses to risk<br />• 21% increase in execution ROI<br />• Reduced costs via earlier detection and automation",
        },
        {
          question: "How soon will I see results?",
          answer:
            "You’ll start seeing automated alerts and suggestions within hours. Within days, the Engine will begin tracking decisions and reporting impact.",
        },
      ],
    },
    {
      category: "Workflow & Integrations",
      questions: [
        {
          question: "Does it work with my current tools?",
          answer:
            "Yes. Radar+ connects with Google Workspace, Microsoft 365, Slack, Asana, and ERP systems like NetSuite and QuickBooks. More integrations are always being added.",
        },
        {
          question: "Can it auto-create tasks and documents?",
          answer:
            "Absolutely. Based on detection, the Engine will generate tasks, documents, summaries, and route them to the correct people or tools automatically.",
        },
      ],
    },
    {
      category: "Security & Control",
      questions: [
        {
          question: "Is my data safe?",
          answer:
            "Yes. We use bank-grade encryption, are GDPR compliant, and offer full audit logs. Your data is yours — we don’t share it, sell it, or use it for training.",
        },
        {
          question: "Can I control what the Engine sees?",
          answer:
            "100%. You control every integration and data flow. You can also restrict automation to review-only for full oversight.",
        },
      ],
    },
    {
      category: "Plans & Billing",
      questions: [
        {
          question: "Do you offer a free trial?",
          answer:
            "Yes — all users get 14 days full access to the Pro plan with no credit card required.",
        },
        {
          question: "What happens if I cancel?",
          answer:
            "You can cancel anytime. Your data remains safe and accessible, and no further charges will apply.",
        },
      ],
    },
  ];

  return (
    <>
      <NavigationBar />
      <div className="faq-page">
        <div className="faq-header">
          <h1>FAQ</h1>
          <p>
            Need more? Contact{" "}
            <a href="mailto:info@roradar.com">info@roradar.com</a>.
          </p>
        </div>
        <div className="faq-container">
          {faqData.map((category, categoryIndex) => (
            <div key={categoryIndex} className="faq-category">
              <h2 className="faq-category-title">{category.category}</h2>
              {category.questions.map((qa, questionIndex) => {
                const key = `${categoryIndex}-${questionIndex}`;
                const isOpen = openQuestion === key;
                return (
                  <div
                    key={questionIndex}
                    className={`faq-item ${isOpen ? "open" : ""}`}
                  >
                    <div
                      className="faq-question"
                      onClick={() =>
                        toggleQuestion(categoryIndex, questionIndex)
                      }
                    >
                      <span className="faq-icon">{isOpen ? "–" : "+"}</span>
                      <span>{qa.question}</span>
                    </div>
                    <div
                      className={`faq-answer ${isOpen ? "visible" : "hidden"}`}
                      dangerouslySetInnerHTML={{ __html: qa.answer }}
                    />
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default FAQ;
